import React from 'react';
import { layoutComponentsMapping } from './fluent-grid-layout-components';

export const Factory = ({
  children,
  node,
  rootId,
  dynamicComponentRender,
}) => {
  let nodeComponent = null;
  const {
    type, children: childNodes, ...rest
  } = node;

  if (layoutComponentsMapping[type]) {
    const LayoutComponent = layoutComponentsMapping[type];
    nodeComponent = <LayoutComponent {...rest}>{children}</LayoutComponent>;
  } else {
    nodeComponent = dynamicComponentRender({ type, rootId, ...rest });
  }
  return nodeComponent;
};
